
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.84 2.4L3.366 8.193c-.206.22-.406.653-.446.953l-.247 2.16c-.087.78.473 1.314 1.247 1.18l2.146-.366c.3-.053.72-.273.927-.5l5.473-5.794c.947-1 1.374-2.14-.1-3.533C10.9.913 9.786 1.4 8.84 2.4zM7.928 3.366A4.084 4.084 0 0011.56 6.8M2 14.667h12","stroke":"#515952","stroke-width":"1.222","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    